import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
  signal,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Drawer } from 'primeng/drawer';
import { Guid, Nillable } from '@web/utils';
import { DrawerTitleComponent, PrimengDrawerDirective } from '@web/shared/ui';
import { AdminBrandBannerListComponent } from '../admin-brand-banner-list/admin-brand-banner-list.component';
import { AdminBrandBannerCreateComponent } from '../admin-brand-banner-create/admin-brand-banner-create.component';
import { AdminBrandBannerEditComponent } from '../admin-brand-banner-edit/admin-brand-banner-edit.component';
import { AdminBrandBannerDetailsComponent } from '../admin-brand-banner-details/admin-brand-banner-details.component';

type DrawerMode = 'create' | 'details' | 'edit';

@Component({
  selector: 'app-admin-brand-banner-management',
  imports: [
    AdminBrandBannerCreateComponent,
    AdminBrandBannerDetailsComponent,
    AdminBrandBannerEditComponent,
    AdminBrandBannerListComponent,
    CommonModule,
    Drawer,
    DrawerTitleComponent,
    PrimengDrawerDirective,
  ],
  templateUrl: './admin-brand-banner-management.component.html',
  styleUrl: './admin-brand-banner-management.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminBrandBannerManagementComponent {
  public readonly brandId = input.required<Guid>();
  public readonly changedEvent = output<void>();

  protected readonly activeBannerId = signal<Nillable<Guid>>(null);
  protected readonly drawerMode = signal<Nillable<DrawerMode>>(null);
  protected readonly reloadVersion = signal(0);

  protected get isDrawerVisible(): boolean {
    return this.drawerMode() !== null;
  }

  protected handleCreateClickEvent(): void {
    this.activeBannerId.set(null);
    this.drawerMode.set('create');
  }

  protected handleEditClickEvent(id: Guid): void {
    this.activeBannerId.set(id);
    this.drawerMode.set('edit');
  }

  protected handlePreviewClickEvent(id: Guid): void {
    this.activeBannerId.set(id);
    this.drawerMode.set('details');
  }

  protected handleChangedEvent(): void {
    this.reloadVersion.update((value) => value + 1);
    this.changedEvent.emit();
  }

  protected handleSubmitSuccessEvent(): void {
    this.handleChangedEvent();
    this.handleDrawerCloseEvent();
  }

  protected readonly customCloseEvent = () => {
    this.handleDrawerCloseEvent();
  };

  private handleDrawerCloseEvent(): void {
    this.drawerMode.set(null);
    this.activeBannerId.set(null);
  }
}
